import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { computed } from 'vue';
import { enrichContentTagsHtml } from '@/js/utils/enrich-content-tags-html';


export default /*@__PURE__*/_defineComponent({
  __name: 'content-tags-html',
  props: {
    html: {}
  },
  setup(__props: any) {

const props = __props;

const enrichedHtml = computed(() => enrichContentTagsHtml(props.html));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "content-tags",
    innerHTML: enrichedHtml.value
  }, null, 8, _hoisted_1))
}
}

})